
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React, { Fragment } from 'react';
import BasePageLayout from '#layouts/BasePageLayout/BasePageLayout';
import Tabs from '#components/navigation/tabs/Tabs';
import HeroUnit from '#components/sections/hero-unit/HeroUnit';
import RichText from '#components/common/richText/RichText';
import SocialMeta from '#components/common/meta/SocialMeta';
import PageSection from '#components/sections/page-section/PageSection';
import EpisodeExplorer from '#modules/series-details/EpisodeExplorer';
import EpisodeExplorerV2 from '#modules/series-details/EpisodeExplorer.v2';
import dynamic from 'next/dynamic';
import {
  GetAnnouncementDocument,
  GetNavigationDocument,
  GetSeriesPageDocument,
  useGetSeriesPageQuery,
} from '#types/generated/apollo-client';
import getRoute from '#utils/getRoute';
import useTranslation from 'next-translate/useTranslation';
import HorizontalScrollList from '#components/lists/horizontal-scroll-list/HorizontalScrollList';
import SpecialTeaser from '#components/teasers/special-teaser/SpecialTeaser';
import { getPlayerInstance, handlePlayerPlay } from '#utils/player/controls';
import { useOvermindActions } from '#store/overmind';
import initializeClient from '#providers/apollo/initializeClient';
import addApolloState from '#providers/apollo/addApolloState';
import { useNewPlayer } from '#hooks';

const SeriesHeroButtonParade = dynamic(
  () => import('#modules/series-details/SeriesHeroButtonParade'),
  {
    ssr: false,
  }
);

const SeriesDetail = ({ slug }) => {
  const { t } = useTranslation();
  const { usePlayerV2 } = useNewPlayer();

  const {
    player: { initPlayer },
  } = useOvermindActions();

  const { data } = useGetSeriesPageQuery({
    variables: { slug },
    initialFetchPolicy: 'cache-only',
    skip: !slug,
  });

  const series = data?.seriesBySlug;

  const renderSliderItem = (item) => {
    return (
      <SpecialTeaser
        key={item.id}
        teaserDataRaw={item}
        disableLikeButton={true}
        disableLinkRedirection={true}
        onClick={(event) => {
          event.stopPropagation();
          initPlayer({ iri: item.iri });

          const player = getPlayerInstance();

          if (player && player.paused()) {
            handlePlayerPlay(player);
          }
        }}
      />
    );
  };

  const renderTabs = () => {
    const tabItems = [];

    tabItems.push({
      title: t('Episodes'),
      component: usePlayerV2 ? (
        <EpisodeExplorerV2 seriesId={series?.id} />
      ) : (
        <EpisodeExplorer seriesId={series?.id} />
      ),
    });

    if (series?.description) {
      tabItems.push({
        title: t('Details'),
        component: (
          <div className="tw-max-w-page-xs">
            <RichText text={series.description} />
          </div>
        ),
      });
    }

    if (series.extras?.length > 0) {
      tabItems.push({
        title: t('Extras'),
        component: (
          <HorizontalScrollList
            direction="landscape"
            items={series.extras}
            renderItem={renderSliderItem}
          />
        ),
      });
    }

    return <Tabs tabItems={tabItems} />;
  };

  return (
    <BasePageLayout>
      <Fragment>
        <SocialMeta
          about={{
            title: series?.title,
            description: series?.shortDescription,
            image: series?.teaserImageFormats?.sixteenByNine?.large,
          }}
        />
        <main className="page-main-container">
          <HeroUnit
            categories={series?.categories}
            backgroundImageFormats={series?.backgroundImageFormats}
            title={series?.title}
            titleImage={series?.logoImageFormats?.sixteenBySeven?.medium}
            brandName={series?.title}
            brandLogoImage={series?.logoImageFormats?.oneByOne?.small}
            studioName={series?.studio?.title}
            studioLogoImage={series?.studio?.logoImageFormats?.oneByOne?.small}
            studioUrl={getRoute(series?.studio, t)}
            subtitle={series?.leadin}
            description={series?.shortDescription}
            buttonComponent={
              <SeriesHeroButtonParade seriesId={series?.id} series={series} />
            }
          />
          <PageSection classes="medium-down:tw-pt-1 large-up:tw-pt-7">
            {!!series && renderTabs()}
          </PageSection>
        </main>
      </Fragment>
    </BasePageLayout>
  );
};

 async function _getServerSideProps(context) {
  const slug = context.query.series as string;
  const client = initializeClient({
    context,
  });

  const queries = await Promise.allSettled([
    client.query({
      query: GetSeriesPageDocument,
      variables: { slug },
    }),
    client.query({
      query: GetAnnouncementDocument,
    }),
    client.query({
      query: GetNavigationDocument,
      variables: { name: 'Main' },
    }),
    client.query({
      query: GetNavigationDocument,
      variables: { name: 'Footer' },
    }),
    client.query({
      query: GetNavigationDocument,
      variables: { name: 'Profile' },
    }),
  ]);

  const seriesResult = queries[0];

  if (
    seriesResult.status !== 'fulfilled' ||
    !seriesResult?.value?.data?.seriesBySlug
  ) {
    return {
      notFound: true,
    };
  }

  return addApolloState(client, { props: { slug } });
}

export default SeriesDetail;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/series/[series]/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  